import {Component, ElementRef, Input, OnInit, ViewChild} from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";
import {ActivatedRoute} from "@angular/router";
import {ResizeEvent} from "angular-resizable-element";
import { ToastrService } from "ngx-toastr";
import {environment} from "../../../../environments/environment";
import {Event} from "../../../models/event";
import {EventType} from "../../../models/event-type";
import {Registration} from "../../../models/registration";
import { ServiceObject } from "../../../models/service-object";
import { ObjectControllerService } from "../../../services/object-controller/object-controller.service";
import { PreviewTranslationsControllerService } from "../../../services/preview-translations-controller/preview-translations-controller.service";
import { BaseError } from "../base-error";
import {Service} from "../../../models/service";
import {ServiceControllerService} from "../../../services/service-controller/service-controller.service";
import {Store} from "../../../services/store.service";
import {AuthService} from "../../../services/auth/auth-service";
import { Location } from "@angular/common";
import {TranslateService} from "@ngx-translate/core";
import {DeterminantControllerService} from "../../../services/registration-controller/determinant-controller.service";

@Component({
  selector: "app-preview2",
  templateUrl: "./preview2.component.html",
  styleUrls: ["./preview2.component.scss"],
  providers: [PreviewTranslationsControllerService, ObjectControllerService],
})
export class Preview2Component extends BaseError implements OnInit {

  @ViewChild("childModal") public childModal;
  public style: object = {};
  @ViewChild("previewIframe")
  public previewIframe: ElementRef;
  public messageEvent: any;
  public previewUrl: any = "";
  public isPreviewLoading = true;
  public fieldKey = "";
  public action = "";
  public scrollHeight = 2500;
  public previewTranslation: any;
  public serviceId: string;
  public registration: Registration;
  public translations: any[];
  public receiveMessage: any = (event: any) => this.handlePreviewMessage(event);
  public iframeWindow: any;
  public searchValue: string = "";
  public editCellId: string = "";
  public translationsFilter: string;
  public isFullScreen: boolean = false;
  public serviceObject: ServiceObject;
  public service: Service;
  public determinantMapById: { [key: string]: string } = {};

  constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute,
              private previewTranslationController: PreviewTranslationsControllerService,
              private objectControllerService: ObjectControllerService,
              private serviceControllerService: ServiceControllerService,
              private determinantService: DeterminantControllerService,
              public store: Store,
              public translate: TranslateService,
              public toastr: ToastrService, private authService: AuthService,
              public location: Location) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      if (params.serviceId && params.serviceId !== "new") {
        this.serviceId = params.serviceId;
        this.getServiceDeterminantKeyName();
        const pageName = window.location.hash.substring(1).split("__");

        this.serviceControllerService.getService(this.serviceId).subscribe(
            async (data: Service) => {
              this.service = data;
              const tokenJWT = await this.authService.getToken();
              let previewUrl = `${environment.E_REGISTRATIONS_URL}redirect-to-service/${this.serviceId}?page=${pageName[1]}&role_name=applicant&tokenJWT=${tokenJWT}`;
              previewUrl += "&lang=" + (this.translate.currentLang || this.translate.getDefaultLang());
              this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(previewUrl);
              this.showPreview();
            }, (err) => {
              this.showErrorMessage(err);
            },
        );
      } else {
        this.serviceId = null;
      }
    });
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public showPreview() {
    if (window.addEventListener) {
      window.addEventListener("message", this.receiveMessage.bind(this), false);
      const timer = setInterval(() => {
        if (this.iframeWindow) {
          // wait until iframe loaded
          setTimeout(() => {
            this.sendPostMessage();
          }, 5000);
          clearInterval(timer);
        }
      }, 500);
    } else {
      (window as any).attachEvent("onmessage", this.receiveMessage.bind(this));
    }
    this.isPreviewLoading = false;
  }

  public sendPostMessage(): void {
    if (!this.iframeWindow) {
      this.iframeWindow = this.previewIframe.nativeElement.contentWindow;
    }
    if (this.iframeWindow) {
      this.iframeWindow.postMessage({action: "get_all_translations"}, "*");
    }
  }

  public showEdit() {
    if (this.action && this.action !== "resize") {
      this.childModal.show();
    }
  }

  public async handlePreviewMessage(messageStr: any) {
    let message: any;
    if (messageStr.data && typeof messageStr.data === "string") {
      message = {};
      try {
        message.data = JSON.parse(messageStr.data);
      } catch (e) {
        message.data = messageStr.data;
      }
    } else {
      message = messageStr;
    }
    if (message.data && message.data.action) {
      this.action = message.data.action;
      this.messageEvent = message;

      if (this.action === "resize") {
        this.scrollHeight = message.data.scrollHeight;
      }

      if (this.action === "translation_edit") {
        this.previewTranslation = {
          key: message.data.key,
          value: message.data.translation,
          language: message.data.lang,
        };
      }

      if (this.action === "get_token") {
        const tokenJWT = await this.authService.getToken();
        this.replyMessage({action: "get_token_resp", token_jwt: tokenJWT});
      }

      if (this.action === "get_all_translations_resp") {
        this.translations = message.data.translations;
      }

      if (message.data.service_id && !this.serviceId) {
        this.serviceId = message.data.service_id;
      }
      this.fieldKey = message.data.data_id;

      if (this.action === "edit") {
        this.objectControllerService.getServiceObject(this.serviceId, this.fieldKey).subscribe(
          (data) => {
            this.serviceObject = data;
            this.showEdit();
          },
          (err) => this.showErrorMessage(err),
        );
      } else if (this.action !== "get_token" && this.action !== "get_all_translations_resp") {
        // Actually there could be more blocked values and I think we should only allow some predefined actions as array.{
        this.showEdit();
      }
    }
  }

  public validate(event: ResizeEvent): boolean {
    const MIN_DIMENSIONS_PX = 420;
    if (event.rectangle.width < MIN_DIMENSIONS_PX || event.rectangle.height < MIN_DIMENSIONS_PX) {
      return false;
    }
    return true;
  }

  public onResizeEnd(event: ResizeEvent): void {
    this.style = {
      position: "fixed",
      width: `${event.rectangle.width}px`,
    };
  }

  public replyMessage(message) {
    this.messageEvent.source.postMessage(message, "*");
  }

  public closeModal(event: Event) {
    if (event.eventType === EventType.Add || event.eventType === EventType.Delete || event.eventType === EventType.Update) {
      this.replyMessage({action: "bpa_requests_reload"});
    }
    this.childModal.hide();
  }

  public saveTranslation({key, translation, lang}) {
    this.previewTranslationController.setPreviewTranslation({key, language: lang, value: translation}).subscribe(
      () => this.responseSuccessful("Translation saved"),
      (err) => this.showErrorMessage(err),
    );
  }

  public getTranslationsFilter(translationsFilter) {
    if (!translationsFilter) {
        return "";
    }

    translationsFilter = translationsFilter.toLowerCase();

    const cmp = (value) => {
        return (value ? ("" + value).toLowerCase().indexOf(translationsFilter) !== -1 : false);
    };

    return (translation) => {
      if (translation === null) {
        return;
      }
      if (this.editCellId && this.editCellId === translation.key) {
        return true;
      }
      if (cmp(translation.key)) {
        return true;
      }
      if (cmp(translation.translation)) {
        return true;
      }
    };
  }

  public toggleFullScreenPreview() {
    this.isFullScreen = !this.isFullScreen;
  }

}
